export default (x) => x;
